<template>
  <div class="dropdown-menu"
    id="dropdown-menu"
    role="menu">
    <div class="dropdown-content"
      ref="dropdownContent"
      style="white-space: nowrap; overflow-x: auto; min-width: 250px; max-width: 100vw; max-height: 300px; overflow-y: auto;">
      <div class="pl-4 pr-4 is-flex is-justify-content-space-between">
        <span>Please Select</span>
        <button v-if="selectedTags.length > 0"
          @click="resetSelectedTags">
          <span class="icon">
            <i class="mdi mdi-refresh mdi-18px" />
          </span>
          <span>Clear All</span>
        </button>
      </div>
      <div class="dropdown-item is-flex is-align-items-center"
        v-for="tag in tags"
        :key="tag.tagID"
        @click="toggleTag(tag)"
        style="cursor: pointer">
        <span class="tag-short mr-2"
          :style="{ backgroundColor: tag.colorHex, color: getTextColor(tag.colorHex) }">{{ tag.shortTag }}</span>
        <span class="mr-auto">{{ tag.tagName }}</span>
        <div class="pretty p-icon p-curve p-smooth p-bigger ml-2 ">
          <input type="checkbox"
            :checked="selectedTags.includes(tag.tagID)"
            @change.stop="toggleTag(tag)"
            @click.stop
            style="cursor:pointer">
          <div class="state p-primary"
            @click.stop="toggleTag(tag)"
            style="cursor:pointer">
            <i class="icon mdi mdi-check" />
            <label />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTextColor } from '../../utils/ColorFunctions'

export default {
  name: 'TagsDropdownMenu',
  props: {
    tags: {
      type: Array,
      required: true
    },
    selectedTags: {
      type: Array,
      required: true
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  watch: {
    isVisible(newVal) {
      if (newVal) {
        // When dropdown becomes visible, scroll to top
        this.$nextTick(() => {
          this.scrollToTop()
        })
      }
    }
  },
  methods: {
    getTextColor,
    toggleTag(tag) {
      this.$emit('toggle-tag', tag)
    },
    resetSelectedTags() {
      this.$emit('clear-all-tags')
    },
    scrollToTop() {
      if (this.$refs.dropdownContent) {
        this.$refs.dropdownContent.scrollTop = 0
      }
    }
  }
}
</script>
